<icz-circulation-table
  tableTitle="Úkony"
  tableId="file-detail-activities"
  [dataSource]="dataSource"
  [viewType]="CirculationView.DOCUMENT_ACTIVITIES"
>

  <icz-label noDataLabel label="Žádné úkony"></icz-label>

</icz-circulation-table>
